<app-network-banner />
<app-error-modal />
<main class="app-container">
  <router-outlet />
</main>
<!-- <app-ai-assistant-floating /> -->
